import { logUtil } from "@repo/lib-common";

export type DomainSubjectCallback<T> = (data: T | undefined) => void;

export abstract class DomainSubject<T> {

    private data?: T;
    name?: string;
    subscriptions: DomainSubjectCallback<T>[] = new Array<DomainSubjectCallback<T>>;
    mustBeTriggeredOnce = false;
    isTriggered = false;
    isInitialized = false;
    constructor() {

    }
    setData(data?: T) {
        this.data = data;
    }
    setDataAndTrigger(data?: T) {
        this.data = data;
        this.trigger();
    }
    getData() {
        return this.data ?? {} as T;
    }
    public subscribe(fn: DomainSubjectCallback<T>) {

        this.subscriptions.push(fn);
        if (this.isTriggered && fn) {
            fn(this.data);
        }
    }
    public onBeforeTrigger?: VoidFunction;
    public onAfterTrigger?: VoidFunction;
    private maxRetryCount = 3;
    private retryCount = 0;
    public trigger() {
        this.isTriggered = true;
        logUtil.consoleLog(`${this.name} is triggered, data:`, this.data);
        if (this.mustBeTriggeredOnce && this.isTriggered) return;
        if (this.subscriptions.length === 0 || this.retryCount >= this.maxRetryCount) return;
        if (this.subscriptions.length === 0) {
            this.retryCount++;
            setTimeout(() => {
                this.trigger();
            }, 2000)
            return;
        }
        logUtil.consoleLog(`${this.name} callbacks are triggered`)
        for (let i = 0; i < this.subscriptions.length; i++) {
            const fn = this.subscriptions[i];
            if (fn) {
                fn(this.data);
            }
        }
        this.retryCount = 0;
    }

    activate() {

        if (this.isInitialized) {
            logUtil.consoleLog(`${this.name} is alreaedy activated`);
            return;
        }
        this.isInitialized = true;
        this.init();
        return this;

    }

    abstract init(): void
    // init(){
    //     throw Error("override init on derived class");
    // };


}





